const { ObjectID } = require('bson');

function autoConvert(obj) {
    if (Array.isArray(obj)) {
        return obj.map(autoConvert);
    } else if (typeof obj === 'string') {
        if (obj.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)((-(\d{2}):(\d{2})|Z)?)$/)) {
            let date = new Date(obj);
            if (!isNaN(date)) return date;
        }
        try {
            return new ObjectID(obj);
        } catch (e) { }
    } else if (obj instanceof Object) {
        return Object.fromEntries(Object.entries(obj).map(([key, value]) => ([key, autoConvert(value)])));
    }
    return obj;
}

module.exports = autoConvert;